import { render, staticRenderFns } from "./CustomerServiceSelector.vue?vue&type=template&id=afc0aee0&scoped=true&"
import script from "./CustomerServiceSelector.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceSelector.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServiceSelector.vue?vue&type=style&index=0&id=afc0aee0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc0aee0",
  null
  
)

export default component.exports